import React from 'react';

import Tabs, { Tab } from 'pages/components/Tabs';

import { logPropTypes } from './utils';
import AuditTrailDetailsAction from './AuditTrailDetailsAction';
import AuditTrailDetailsClient from './AuditTrailDetailsClient';
import AuditTrailDetailsUser from './AuditTrailDetailsUser';
import AuditTrailDetailsMessage from './AuditTrailDetailsMessage';
import AuditTrailDetailsMeta from './AuditTrailDetailsMeta';

const AuditTrailDetails = props => {
  const { log } = props;

  return (
    <Tabs>
      <Tab title="Action Details" active>
        <AuditTrailDetailsAction log={log} />
      </Tab>
      <Tab title="Client Details">
        <AuditTrailDetailsClient log={log} />
      </Tab>
      <Tab title="User Details">
        <AuditTrailDetailsUser log={log} />
      </Tab>
      <Tab title="Message">
        <AuditTrailDetailsMessage log={log} />
      </Tab>
      <Tab title="Meta Data">
        <AuditTrailDetailsMeta log={log} />
      </Tab>
    </Tabs>
  );
};

AuditTrailDetailsClient.propTypes = {
  log: logPropTypes,
};

export default AuditTrailDetails;
